<template>
    <v-card flat>
        <v-card-text>
            <v-container>
                <p><strong>Tipo:</strong> {{ selectedItem.is_pj ? "Pessoa Jurídica" : "Pessoa Física" }}</p>
                <v-row>
                    <v-col cols="4" sm="4" md="4">
                        <v-text-field
                            :value="selectedItem.first_name"
                            label="Nome"
                            readonly
                            hide-details="auto"
                        ></v-text-field>
                    </v-col>

                    <v-col cols="4" sm="4" md="4">
                        <v-text-field
                            :value="selectedItem.last_name"
                            label="Sobrenome"
                            readonly
                            hide-details="auto"
                        ></v-text-field>
                    </v-col>

                    <v-col cols="4" sm="4" md="4">
                        <v-text-field
                            :value="selectedItem.social_reason"
                            label="Razão Social"
                            readonly
                            hide-details="auto"
                        ></v-text-field>
                    </v-col>

                    <v-col cols="4" sm="4" md="4">
                        <v-text-field
                            :value="selectedItem.birthday | formatDate"
                            label="Data de Nascimento"
                            readonly
                            hide-details="auto"
                        ></v-text-field>
                    </v-col>

                    <v-col cols="4" sm="4" md="4">
                        <v-text-field
                            :value="selectedItem.cpf"
                            label="CPF"
                            readonly
                            hide-details="auto"
                        ></v-text-field>
                    </v-col>

                    <v-col cols="4" sm="4" md="4">
                        <v-text-field
                            :value="selectedItem.cnpj"
                            label="CNPJ"
                            readonly
                            hide-details="auto"
                        ></v-text-field>
                    </v-col>

                    <v-col cols="4" sm="4" md="4">
                        <v-text-field
                            :value="selectedItem.passport"
                            label="Passaporte"
                            readonly
                            hide-details="auto"
                        ></v-text-field>
                    </v-col>

                    <v-col cols="4" sm="4" md="4">
                        <v-text-field
                            :value="selectedItem.driving_license"
                            label="CNH"
                            readonly
                            hide-details="auto"
                        ></v-text-field>
                    </v-col>

                    <v-col cols="3" sm="3" md="3">
                        <v-text-field
                            :value="selectedItem.rg_number"
                            label="RG"
                            readonly
                            hide-details="auto"
                        ></v-text-field>
                    </v-col>

                    <v-col cols="4" sm="4" md="4">
                        <v-text-field
                            :value="selectedItem.rg_issue_date | formatDate"
                            label="Data de Emissão"
                            readonly
                            hide-details="auto"
                        ></v-text-field>
                    </v-col>

                    <v-col cols="4" sm="4" md="4">
                        <v-text-field
                            :value="selectedItem.rg_issuer"
                            label="Órgão Emissor"
                            readonly
                            hide-details="auto"
                        ></v-text-field>
                    </v-col>

                    <v-col cols="4" sm="4" md="4">
                        <v-text-field
                            :value="selectedItem.rg_state"
                            label="Estado Emissor"
                            readonly
                            hide-details="auto"
                        ></v-text-field>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
    </v-card>
</template>


<script>
export default {
  name: 'Client',
  props: {
    selectedItem: {
        type: Object,
        required: true,
    },
  },
}
</script>
